/** Comma-separated multiselect values for AI assist dialogs. */
export function parseCsvSelection(raw: string | undefined): string[] {
    if (!raw?.trim()) return [];
    return raw
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
}

export function serializeCsvSelection(values: string[]): string {
    return values.join(',');
}

export function toggleCsvSelection(raw: string | undefined, value: string): string {
    const current = parseCsvSelection(raw);
    const next = current.includes(value) ? current.filter(v => v !== value) : [...current, value];
    return serializeCsvSelection(next);
}
